import { getDefaultReportConfiguration } from 'application/Home/Reports/helpers';
import { Helpers } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';
import { useParams, useSearchParams } from 'react-router';

/**
 * Custom hook to extract and parse report parameters from URL search params
 * @param reportType - The type of report to get parameters for
 * @returns Parsed report parameters object or default configuration if parsing fails
 */
export const useReportParams = (reportType: string | undefined) => {
    const [searchParams] = useSearchParams();
    const { clientId } = useParams();

    // scheduledReports run from the backend encode the reportParams
    const decodeReportParams = searchParams.get('decodeReportParams');

    // Return empty object if no report type provided
    if (!reportType) return {};

    const defaultConfig = getDefaultReportConfiguration({
        clientId,
        reportType
    });

    const reportParamsFromSearchParams = searchParams.get('reportParams');

    if (reportParamsFromSearchParams) {
        try {
            // Decode base64 if params are encoded, otherwise use raw params
            const reportParamsBeforeParsing = Helpers.convertToBoolean(
                decodeReportParams
            )
                ? atob(reportParamsFromSearchParams)
                : reportParamsFromSearchParams;

            // Parse the JSON string into an object
            const parsedReportParams = JSON.parse(reportParamsBeforeParsing);
            return parsedReportParams;
        } catch (e) {
            // Log warning and return default config if parsing fails
            debug.w('Error parsing reportParams from searchParams', e);
            return defaultConfig;
        }
    }
    // Return default configuration if no params found in URL
    return defaultConfig;
};
